import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';

import { Link } from "react-router-dom";
import { makeInput } from "common-import/custom";
import { VarHelper } from "common-import/helpers";

import { inject, observer } from "mobx-react";

@inject("contractorStore", "userStore") @observer
class ContractorList extends Component {

  state = {
    keyword: "",
    page: 1
  }

  async componentDidMount() {
    const { contractorStore } = this.props;
    await this.props.userStore.onReady();
    let getListResult = await contractorStore.getListNotApproved();
    if(!!getListResult.error) window.toast.error("Có lỗi xảy ra, vui lòng thử lại   "+ JSON.stringify(getListResult.error));
  }

  renderRow(data, index) {
    return (

      <tr key={"row"+index}>
        <td className="text-center">
          <div className="avatar">
            <img src={VarHelper.img(data.logo) || 'img/avatars/contractor-07.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com" />
            {/* <span className="avatar-status badge-success"></span> */}
          </div>
        </td>
        <td>
          <Link to={`/contractor/${data.id}?name=${data.contractor}`}>
            <div>{data.contractor}</div>
            <div className="small text-muted">
              <span>Email</span>: {data.email}
            </div>
            <div className="small text-muted">
              <span>Tel</span>: {data.tel}
            </div>
            <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.address}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.lisence}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="small text-muted">{data.website}</div>
        </td>
        <td>
          <div className="small text-muted">{data.ranking}</div>
        </td>
      </tr>

    )
  }

  render() {
    const { contractorStore } = this.props;
    const listNotApproved = contractorStore.listNotApproved.slice();
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm nhà thầu chưa xác thực" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><i className="icon-people"></i></th>
                  <th>Contractor</th>
                  <th>Address</th>
                  <th>License Number</th>
                  <th>Website</th>
                  <th>Ranking</th>
                </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
                {listNotApproved.length > 0 && listNotApproved.map((val, index) => this.renderRow({
                  id: val.id,
                  contractor: val.name,
                  email: val.email,
                  tel: val.phone,
                  fax: val.fax,
                  address: val.address,
                  lisence: "Contractor",
                  website: val.website,
                  ranking: val.totalRanking,
                  logo: val.logo
                }, index) )}
              </tbody>
            </Table>
            {listNotApproved.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Hiện chưa có nhà thầu nào chưa được xác thực</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
              <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>        
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { contractorStore } = this.props;
    const { keyword } = this.state;
    if(keyword == "") {
      contractorStore.getListNotApproved();
    } else {
      contractorStore.search(keyword, 0);
    }
  }

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { contractorStore } = this.props;
    this.setState({ page: this.state.page - 1}, () => {
      contractorStore.getListNotApproved(this.state.page);
    });
  }

  loadNext = e => {
    !!e && e.preventDefault();
    const { contractorStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      contractorStore.getListNotApproved(this.state.page);
    });
  }
}

export default ContractorList;


// WEBPACK FOOTER //
// ./src/views/Contractors/NotApprovedList.js